<p-dropdown [formControl]="$any(formControl)" [filter]="true" [placeholder]="to.placeholder || ''"
  [options]="to.options | formlySelectOptions: field | async" [autoDisplayFirst]="false" [formlyAttributes]="field"
  [showClear]="to.showClear != null ? to.showClear : !to.required"
  (ngModelChange)="to.change && to.change(field, $event)" [virtualScroll]="true" [itemSize]="to.itemSize || 30"
  [readonly]="to.readonly" appendTo="body" [scrollHeight]="'150px'" [pTooltip]="to?.tooltip || undefined"
  [style]="{'width':'100%'}"></p-dropdown>